
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';


const TiempoClase = ({ promptData, setPromptData }) => {

    const handleTiempoClase = (event) => {
        const { value } = event.target;
        
        setPromptData((prevData) => ({
            ...prevData,
            tiempo_clase: value 
          }));
      };

    return (
        <Grid sx={{ mb: 3 }}>
        <FormControl component="fieldset">
            <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }}>Tiempo de la clase *</Typography>
            <RadioGroup
                aria-label="tiempo-clase"
                value={promptData.tiempo_clase}
                onChange={handleTiempoClase}
                row
            >
                <Grid display={'flex'} flexDirection={'column'}>
                    <FormControlLabel sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'montserrat', fontSize: '14px', fontWeight: 'normal' } }} value="45" control={<Radio />} label="45 minutos" />
                    <FormControlLabel sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'montserrat', fontSize: '14px', fontWeight: 'normal' } }} value="90" control={<Radio />} label="90 minutos" />
                    <FormControlLabel sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'montserrat', fontSize: '14px', fontWeight: 'normal' } }} value="135" control={<Radio />} label="135 minutos" />
                </Grid>
            </RadioGroup>
        </FormControl>
    </Grid>
    );
};

TiempoClase.propTypes = {
  promptData: PropTypes.func.isRequired,
  setPromptData: PropTypes.func.isRequired,
};

export default TiempoClase;
